var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrollbar_style",attrs:{"id":"app"},on:{"scroll":function($event){return _vm.onScroll($event)}}},[_c('headers'),_c('div',{staticClass:"router_box"},[_c('router-view'),_c('bottom-navbar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }